import React, { createContext, useState, useEffect } from 'react';

const DataContext = createContext();

const DataProvider = ({ children }) => {
  const [profile, setData] = useState(localStorage.getItem('userName') || 'Emma Shelton');
  const [image, setImage] = useState('profile');

  useEffect(() => {
    const handleStorageChange = () => {
      const newValue = localStorage.getItem('userName') || 'Emma Shelton';
      setData(newValue);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <DataContext.Provider value={{ profile, setData, image, setImage }}>
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };
